<template>
  <div class="home">
    <side-menu />
    <toolbar />
    <v-content>
      <v-container fluid>
        <router-view />
        <pre>{{getCurrentUser}}</pre>
      </v-container>
    </v-content>
  </div>
</template>

<script>
import sideMenu from '@/components/Common/sideMenu'
import toolbar from '@/components/Common/toolbar'
import {mapGetters} from 'vuex'
export default {
  computed: {
    ...mapGetters([
      'getCurrentUser'
    ])
  },
  components: {
    sideMenu,
    toolbar
  }
}
</script>
